var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyClipboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a6vju2sd6a",
    d: "M0 0h12v12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "to72eg21zb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6vju2sd6a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.91 10.364a.545.545 0 0 1-.546.545h-6a.545.545 0 0 1-.546-.545v-6c0-.301.244-.546.546-.546h6a.545.545 0 0 1 .545.546v6zM1.09 7.636v-6c0-.3.245-.545.546-.545h6a.545.545 0 0 1 .546.545v1.091H4.363a1.636 1.636 0 0 0-1.636 1.637v3.818h-1.09a.546.546 0 0 1-.546-.545zm9.274-4.909H9.273v-1.09A1.636 1.636 0 0 0 7.636 0h-6A1.636 1.636 0 0 0 0 1.636v6a1.636 1.636 0 0 0 1.636 1.637h1.091v1.09A1.636 1.636 0 0 0 4.364 12h6A1.637 1.637 0 0 0 12 10.364v-6a1.636 1.636 0 0 0-1.636-1.637z",
    fillOpacity: 0.7,
    fill: "#0A131B",
    mask: "url(#to72eg21zb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.818H7.91v-1.09a.545.545 0 1 0-1.09 0v1.09H5.726a.545.545 0 1 0 0 1.091h1.091V9A.545.545 0 0 0 7.91 9V7.91H9a.545.545 0 1 0 0-1.092z",
    fillOpacity: 0.7,
    fill: "#0A131B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClipboard);
export default __webpack_public_path__ + "static/media/copy-clipboard.6241b5a9f0035dbaa6a6ad7053f28dd7.svg";
export { ForwardRef as ReactComponent };